import { render, staticRenderFns } from "./HeaderFAQ.vue?vue&type=template&id=47d87049&scoped=true"
import script from "./HeaderFAQ.vue?vue&type=script&lang=js"
export * from "./HeaderFAQ.vue?vue&type=script&lang=js"
import style0 from "./css/headerFAQ.css?vue&type=style&index=0&id=47d87049&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d87049",
  null
  
)

export default component.exports